import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import KicaLogo from '../../components/Svg/KicaLogo';


const Container = styled(motion.div)`
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9001;
    top: 0;
    left: 0;
`
const Dim = styled(motion.div)`
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #fff;
`

const Box = styled.div`
    height: 83px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
`
export default function Splash() {
    return (
        <Container>
            <Dim />
            <Box> <KicaLogo width={300} /> </Box>
        </Container>
    );
}

